document.body.addEventListener("change", function (e) {
  const videoPlayer = document.querySelector(".js-course-trailer");
  const { target } = e;
  const isAudioSelector = target.classList.contains("js-trailer-audio-selector");

  if (isAudioSelector) {
    const videoId = target.value;
    const videoStarted = videoPlayer.classList.contains("video-player--playing");

    videoPlayer.setAttribute("id", `video_item_${videoId}`);

    if (videoStarted) {
      Domestika.video_attachable.restart_video_item();
    }
  }
});
